import { Clock, Mail, Rocket } from "lucide-react";
import { useEffect, useState } from "react";

type SuccessContentProps = {
	name: string;
	pedidoId: string;
};

export const SuccessContent = ({ name, pedidoId }: SuccessContentProps) => {
	const [visibleItems, setVisibleItems] = useState<number[]>([]);

	useEffect(() => {
		const timers = [
			setTimeout(() => setVisibleItems((prev) => [...prev, 0]), 1000),
			setTimeout(() => setVisibleItems((prev) => [...prev, 1]), 1200),
			setTimeout(() => setVisibleItems((prev) => [...prev, 2]), 1400),
			setTimeout(() => setVisibleItems((prev) => [...prev, 3]), 1600),
			setTimeout(() => setVisibleItems((prev) => [...prev, 4]), 1800),
			setTimeout(() => setVisibleItems((prev) => [...prev, 5]), 2000),
		];

		return () => timers.forEach((timer) => clearTimeout(timer));
	}, []);

	const contentItems = [
		{
			text: "Parabéns! 👊",
			className: "text-4xl font-bold text-foreground",
		},
		{
			text: "Só bora!",
			className: "text-5xl font-bold text-success mb-8 font-bebas italic",
		},
		{
			text: `Olá ${name}!`,
			className: "text-xl text-foreground mb-4",
		},
		{
			text: (
				<span>
					Recebemos seu pedido{" "}
					<span className="text-success font-mono font-bold">#{pedidoId}</span>.
				</span>
			),
			className: "text-lg text-muted-foreground mb-6 leading-relaxed",
		},
		{
			text: (
				<div className="mb-8 flex items-center gap-3 text-lg text-foreground">
					<Rocket className="text-success animate-float h-6 w-6" />
					<span>
						Seu acesso foi liberado! Vá para o login da plataforma{" "}
						<span className="text-success font-semibold">suportefy</span> e
						acesse na aba{" "}
						<span className="text-success font-semibold">academy</span>!
					</span>
				</div>
			),
			className: "",
		},
		{
			text: (
				<div className="space-y-4 text-muted-foreground">
					<div className="flex items-start gap-3">
						<Clock className="text-success mt-0.5 h-5 w-5 flex-shrink-0" />
						<span>
							Se ao acessar o treinamento ele ainda não estiver liberado,
							aguarde até{" "}
							<span className="text-success font-semibold">1 hora</span>.
						</span>
					</div>
					<div className="flex items-start gap-3">
						<Mail className="text-success mt-0.5 h-5 w-5 flex-shrink-0" />
						<span>
							Se após esse período ainda não estiver disponível, entre em
							contato pelo e-mail{" "}
							<span className="text-primary-glow font-semibold">
								suporte@supportefy.io
							</span>
							.
						</span>
					</div>
				</div>
			),
			className: "",
		},
	];

	return (
		<div className="mx-auto max-w-2xl space-y-6 text-center">
			{contentItems.map((item, index) => (
				<div
					key={index}
					className={`duration-600 transition-all ${
						visibleItems.includes(index)
							? "translate-y-0 opacity-100"
							: "translate-y-8 opacity-0"
					} ${item.className}`}
					style={{ transitionDelay: `${index * 100}ms` }}
				>
					{typeof item.text === "string" ? item.text : item.text}
				</div>
			))}
		</div>
	);
};
